import * as Preact from "preact"
import "@frog/source/views/dev/DevObjectsListUI.less"
import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Keyb from "keyb"

import unitJobs from "@frog/source/data/unit-jobs.js"
import elements from "@frog/source/data/elements.js"

export default class DevObjectsListUI {
    render() {
        if(Dev.loadedProtostage == undefined) return
        let unitFolder
        let spotFolder
        let scriptsFolder
        let encounterFolder

        if(Dev.mode == "battle"
        || Dev.mode == "scripts") {
            unitFolder = (
                <div class="Folder">
                    <div class="Title" onClick={this.onClick("units")}>Units</div>
                    <div class="Items" isExpanded={Dev.isObjectsFolderExpanded.units + ""}>
                        {Object.values(Dev.loadedProtostage?.units).map((unit) => {
                            return <UnitLink unit={unit}/>
                        })}
                    </div>
                </div>
            )
            spotFolder = (
                <div class="Folder">
                    <div class="Title" onClick={this.onClick("spots")}>Spots</div>
                    <div class="Items" isExpanded={Dev.isObjectsFolderExpanded.spots + ""}>
                        {Object.values(Dev.loadedProtostage.world.spots).sort((a,b) => (a.tag > b.tag) ? 1 : ((b.tag > a.tag) ? -1 : 0)).map((spot) => {
                            return <SpotLink spot={spot}/>
                        })}
                    </div>
                </div>
            )
        }
        if(Dev.mode == "scripts") {
            if(Dev.loadedScript == undefined) {
                if(history.state == null
                || history.state.dataFolder == undefined) {
                    scriptsFolder = (
                        <div class="Folder">
                            <div class="Title" onClick={this.onClick("scripts")}>Scripts</div>
                            <div class="Items" isExpanded={Dev.isObjectsFolderExpanded.scripts + ""}>
                                <span class="CatchButton "onClick={() => Dev.readScriptFile()}>
                                    Please load the games folder
                                </span>
                            </div>
                        </div>
                    )
                } else {
                    Dev.readScriptFile()
                    return
                }
            } else {
                scriptsFolder = (
                    <div class="Folder">
                        <div class="Title" onClick={this.onClick("scripts")}>Scripts</div>
                        <div class="Items" isExpanded={Dev.isObjectsFolderExpanded.scripts + ""}>
                            {Object.values(Dev.loadedScript.scenes).map((scene) => {
                                return (
                                    <ScriptLink scene={scene}/>
                                )
                            })}
                        </div>
                    </div>
                )
            }
        }
        if(Dev.mode == "geography") {
            encounterFolder = (
                <div class="Folder">
                    <div class="Title" onClick={this.onClick("encounters")}>Encounters</div>
                    <div class="Items" isExpanded={Dev.isObjectsFolderExpanded.encounters + ""}>
                        {Object.values(Dev.loadedProtostage.world.zones).map((encounter) => {
                            return (
                                <EncounterLink encounter={encounter}/>
                            )
                        })}
                    </div>
                </div>
            )
        }

        return (
            <div class="DevObjectsList">
                <input class="Search" id="search-inspector" type="text"
                    onKeyDown={this.onKey} onKeyUp={this.onKey}
                    placeholder="Search for an object"
                    defaultValue={Dev.navigatorSearchQuery}/>
                {unitFolder}
                {spotFolder}
                {scriptsFolder}
                {encounterFolder}
            </div>
        )
    }
    get onKey() {
        return (event) => {
            Dev.navigatorSearchQuery = event.target.value.trim()
            event.stopPropagation()
        }
    }
    onClick(objectType) {
        return () => {
            Dev.isObjectsFolderExpanded[objectType] = !Dev.isObjectsFolderExpanded[objectType]
            Dev.storeDevSettings()
        }
    }
}

class SpotLink {
    render() {
        return (
            <div class="SpotLink"
                isShown={this.isShown + ""}
                isHovered={this.isHovered + ""}
                onPointerOver={this.onPointerOver}
                onPointerOut={this.onPointerOut}
                onClick={this.onPointerDown}>
                <div class="Name" style={this.style}>{this.props.spot.tag || "Spot"}</div>
                <div class="Key">(#{(this.props.spot.key + "")})</div>
            </div>
        )
    }
    get style() {
        const style = {}
        style.opacity = isOnCamera(this.props.spot.position) ? 1.0 : 0.5

        if(Dev.tagColors[this.props.spot.tag] != undefined) {
            style.color = Dev.tagColors[this.props.spot.tag]
        }
        return style
    }
    get onPointerDown() {
        return () => {
            Dev.devSelection.clearSelected()
            Dev.devSelection.selectedSpotKey = this.props.spot.key
            Dev.storeDevSettings()

            if(Dev.mode == "scripts"
            && Dev.devSelection.selectedSceneStep != undefined
            && (Keyb.isDown("<meta>") == true
            || Keyb.isDown("<control>") == true)) {
                Dev.devSelection.selectedSceneStep.body = Dev.devSelection.selectedSceneStep.body + " " + this.props.spot.key
            }

            const selection = App.game.chapter.selection
            const camPosition = selection.camera.position
            const unitPosition = this.props.spot.position
            selection.centerPositionInCamera(unitPosition)
        }
    }
    get onPointerOver() {
        return () => {
            Dev.devSelection.listHoveredSpotKey = this.props.spot.key
        }
    }
    get onPointerOut() {
        return () => {
            Dev.devSelection.listHoveredSpotKey = undefined
        }
    }
    get isShown() {
        if(Dev.navigatorSearchQuery == ""
        || Dev.navigatorSearchQuery == undefined) return true

        if(this.props.spot.tag != undefined
        && this.props.spot.tag.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(Dev.navigatorSearchQuery.includes(":") == false) return false
        return queryObjectProperties(this.props.spot, Dev.navigatorSearchQuery)
    }
    get isHovered() {
        return Dev.devSelection.listHoveredSpotKey == this.props.spot.key
            || Dev.devSelection.hoveredSpotKey == this.props.spot.key
            || Dev.devSelection.selectedSpotKey == this.props.spot.key
    }
}

class ScriptLink {
    render() {
        return (
            <div class="ScriptLink"
                isShown={this.isShown + ""}
                onClick={this.onClick}>
                <div class="Name">{this.props.scene.comment?.string || "Condition-Scene"}</div>
            </div>
        )
    }
    get onClick() {
        return () => {
            Dev.devSelection.selectedSceneKey = this.props.scene.key
            Dev.storeDevSettings()
        }
    }
    get isShown() {
        if(Dev.navigatorSearchQuery == ""
        || Dev.navigatorSearchQuery == undefined) return true

        if(this.props.scene.comment?.string != undefined
        && this.props.scene.comment.string.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(Dev.navigatorSearchQuery.includes(":") == false) return false
        return queryObjectProperties(this.props.scene, Dev.navigatorSearchQuery)
    }
}

class EncounterLink {
    render() {
        return (
            <div class="EncounterLink"
                isShown={this.isShown + ""}
                isHovered={this.isHovered + ""}
                onPointerDown={this.onPointerDown}
                onPointerOver={this.onPointerOver}
                onPointerOut={this.onPointerOut}>
                {this.props.encounter.slug}
            </div>
        )
    }
    get onPointerOver() {
        return () => {
            Dev.devSelection.listHoveredEncounterKey = this.props.encounter.slug
        }
    }
    get onPointerOut() {
        return () => {
            Dev.devSelection.listHoveredEncounterKey = undefined
        }
    }
    get onPointerDown() {
        return () => {
            Dev.devSelection.clearSelected()
            Dev.devSelection.selectedEncounterKey = this.props.encounter.slug
            Dev.storeDevSettings()

            App.game.chapter.selection.centerPositionInCamera(this.props.encounter)
        }
    }
    get isHovered() {
        return Dev.devSelection.listHoveredEncounterKey == this.props.encounter.slug
            || Dev.devSelection.hoveredEncounterKey == this.props.encounter.slug
            || Dev.devSelection.selectedEncounterKey == this.props.encounter.slug
    }
    get isShown() {
        if(Dev.navigatorSearchQuery == ""
        || Dev.navigatorSearchQuery == undefined) return true

        if(this.props.encounter.slug != undefined
        && this.props.encounter.slug.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(Dev.navigatorSearchQuery.includes(":") == false) return false
        return queryObjectProperties(this.props.encounter, Dev.navigatorSearchQuery)
    }
}

import Objdict from "objdict"
class UnitLink {
    render() {
        return (
            <div class="UnitLink" isShown={this.isShown + ""}
                isHovered={this.isHovered + ""}
                onClick={this.onClick}
                onPointerOver={this.onPointerOver}
                onPointerOut={this.onPointerOut}>
                <div class="Name" style={this.style}>{this.getName()}</div>
                <div class="Key">(#{(this.props.unit.key + "").split("-")[0]})</div>
            </div>
        )
    }
    get unit() {
        let unit = this.props.unit
        if(this.props.unit.cachedProperties != undefined) unit = Objdict.merge(this.props.unit, this.props.unit.cachedProperties)
        return unit
    }
    getName() {
        const unit = this.unit

        return (unit.name
            || unitJobs[unit.jobKey]?.jobName
            || (unit.randomJobKey ? "Random" : undefined)
            || ((unit.type == "zone" || unit.type == "spot") ? "Spawnspot" : undefined)
            || "Unit")
    }
    get style() {
        const unit = this.unit
        const style = {}
        style.opacity = isOnCamera(unit.position) ? 1.0 : 0.5
        if(unit.element != undefined) style.color = elements[unit.element].color

        return style
    }
    get onClick() {
        return () => {
            const selection = App.game.chapter.selection
            const camPosition = selection.camera.position
            const unitPosition = this.props.unit.position
            selection.centerPositionInCamera(unitPosition)
            App.game.chapter.selection.select(this.props.unit.key)
            Dev.devSelection.listHoveredUnitKey = undefined

            if(Dev.mode == "scripts"
            && Dev.devSelection.selectedSceneStep != undefined
            && (Keyb.isDown("<meta>") == true
            || Keyb.isDown("<control>") == true)) {
                Dev.devSelection.selectedSceneStep.body = Dev.devSelection.selectedSceneStep.body + " " + this.props.unit.key
            }
        }
    }
    get onPointerOver() {
        return () => {
            Dev.devSelection.listHoveredUnitKey = this.props.unit.key
        }
    }
    get onPointerOut() {
        return () => {
            Dev.devSelection.listHoveredUnitKey = undefined
        }
    }
    get isShown() {
        if(Dev.navigatorSearchQuery == ""
        || Dev.navigatorSearchQuery == undefined) return true

        if(this.getName().toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(Dev.navigatorSearchQuery.includes(":") == false) return false
        return queryObjectProperties(this.props.unit, Dev.navigatorSearchQuery)
    }
    get isHovered() {
        const selection = App.game.chapter.selection

        return Dev.devSelection.listHoveredUnitKey == this.props.unit.key
            || selection.hoveredUnitKey == this.props.unit.key
            || selection.selectedUnitKey == this.props.unit.key
    }
}

function isOnCamera(position) {
    const cameraZone = App.game.chapter.selection.camera.renderzone

    return cameraZone.x < position.x
        && position.x < cameraZone.x + cameraZone.width
        && cameraZone.y < position.y
        && position.y < cameraZone.y + cameraZone.height
}
function queryObjectProperties(object, query) {
    const searchQueries = query.split(" ")
    const disqualifyingQuery = searchQueries.find((searchQuery) => {

        const queryWords = searchQuery.split(":")
        // if this query isn't fully written out, just ignore it
        if(queryWords.length == 1) return false

        let checkedProperty = object[queryWords[0]]
        if(queryWords[0].includes(".")) {
            const subpropertyChain = queryWords[0].split(".")
            let parent = object
            for(const subpropertyKey of subpropertyChain) {
                parent = parent[subpropertyKey]
                if(parent == undefined) return true
            }
            checkedProperty = parent
        }

        if(checkedProperty == undefined) return true
        checkedProperty = checkedProperty + ""
        return checkedProperty.toLowerCase().includes(queryWords[1]) == false
    })
    return disqualifyingQuery == undefined
}
